import { useContext } from 'react'
import { State, ActiveText } from '../utils/context'
import { resultKey, inFilter } from '../utils/search'
import { useEventListener } from '../utils/hooks'

const Keyboard = () => {
  const [{input, chapters, status, active}, setState] = useContext(State)
  const activeText = useContext(ActiveText)

  const onChange = value => setState(state => ({
    ...state, 
    input: {
      ...state.input,
      chapter: state.input.chapter + value
    }
  }))

  const onClick = () => navigator.clipboard?.writeText(activeText).then(() => setState(state => ({
    ...state,
    active: {
      ...state.active,
      verses: {}
    }
  }))).catch(() => {})

  // Strzałki ↑/↓ przechodzą między polem wyszukiwania, podpowiedziami i wynikami.
  const onMove = (e, step) => {
    const items = [document.querySelector('input[type="search"]'), ...document.querySelectorAll('[data-search-item]')]
    const index = items.indexOf(e.target.closest('input, [data-search-item]'))

    if (index < 0) return

    e.preventDefault()
    items[Math.min(Math.max(0, index + step), items.length - 1)].focus()
  }

  const onSearch = () => setState(state => ({
    ...state,
    active: {
      ...state.active,
      search: true,
      input: true
    }
  }))

  useEventListener(window, 'keydown', e => {
    // Podczas pisania w polu tekstowym strzałki i kopiowanie działają domyślnie.
    const typing = e.target.closest?.('input, textarea')

    if (e.ctrlKey || e.metaKey) {
      switch (e.code) {
        // Zaznaczamy tylko wersety, bez natywnego zaznaczenia nagłówków i podpowiedzi.
        case 'KeyA': !active.input && !typing && (e.preventDefault() || setState(state => ({
            ...state,
            active: {
              ...state.active,
              verses: Object.fromEntries((state.active.search
                ? state.search.results.filter(match => inFilter(state.search.filter, match.book)).map(resultKey)
                : Object.keys(state.output)
              ).map(id => [id, true]))
            }
          })));
        break
        case 'KeyC': activeText && !typing && onClick(); break
        case 'KeyF': e.preventDefault() || setState(state => ({
            ...state,
            active: {
              ...state.active,
              search: true,
              input: !state.active.input
            }
          }));
        break
      }
    }
    else {
      switch (e.code) {
        case 'ArrowLeft': !typing && !active.search && status != 'loading' && input.chapter > 1 && onChange(-1); break
        case 'ArrowRight': !typing && !active.search && status != 'loading' && input.chapter < chapters && onChange(+1); break
        case 'ArrowDown': active.search && onMove(e, +1); break
        case 'ArrowUp': active.search && onMove(e, -1); break
        case 'Slash': !typing && (e.preventDefault() || onSearch()); break
        case 'Escape': e.preventDefault() || setState(state => ({
            ...state,
            active: {
              search: state.active.search && (state.active.input || Object.values(state.active.verses).includes(true)),
              input: false,
              verses: state.active.input || Object.values(state.active.control).includes(true) ? state.active.verses : {},
              control: {}
            }
          }));
        break
      }
    }
  }, [input, chapters, status, active, activeText])

  return null
}

export default Keyboard
